import { Form } from 'factorial-form'

class MoveEmployeeForm extends Form {
  constructor(values: Record<string, number | string | null | undefined>) {
    super(values, {
      location_id: 'number',
    })
  }
}

export default MoveEmployeeForm
